import { Box, CircularProgress, Modal } from '@mui/material'
import React, { useEffect, useState } from 'react'

import { boxStyle } from '../../../constants/types'

import { t } from 'i18next'
import { NotificationManager } from 'react-notifications'
import { useSelector } from 'react-redux'
import trashIcon from '../../../assets/svgs/trash.svg'
import MarketingService from '../../../services/marketingService'
import { identifyVenue, trackEvent } from '../../../utils/mixpanelUtil'

// Translation helper for discount-related text
export const discountText = (text) => t(`marketing.promotions.discounts.${text}`)

export default function DiscountDeleteModal({ showModal, data, onClose }) {
   const { short_code } = useSelector((state) => state.app)

   const [visible, setVisible] = useState(false)
   const [loading, setLoading] = useState(false)
   const [state, setState] = useState()

   useEffect(() => {
      if (showModal) {
         if (data?.id != null) {
            setState(data)
         }
      }
      setVisible(showModal)
   }, [showModal])

   const onSubmit = () => {
      if (state && state.id) {
         setLoading(true)
         MarketingService.DeleteDiscount(state.id)
            .then(({ data }) => {
               identifyVenue(short_code)
               trackEvent('marketing service', {
                  action_category: 'delete',
                  action_outcome: 'success',
                  interaction_element: 'discounts',
               })
               setLoading(false)
               onClose(true)
               NotificationManager.success(
                  data?.message ?? discountText('discount_deleted_successfully')
               )
            })
            .catch((err) => {
               identifyVenue(short_code)
               trackEvent('marketing service', {
                  action_category: 'delete',
                  action_outcome: 'fail',
                  interaction_element: 'discounts',
               })
               setLoading(false)

               // Special handling for discounts used in orders
               if (err?.error?.includes('used in orders')) {
                  NotificationManager.error(discountText('discount_used_in_orders'), '', 5000);
               } else {
                  NotificationManager.error(err?.error ?? t("common.error_generic"))
               }
            })
      }
   }

   return (
      <div>
         <Modal
            open={visible}
            onClose={onClose}
            className="discount-modal"
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
         >
            <Box sx={{ ...boxStyle, width: 400 }} className="outline-none">
               <div className="flex flex-row items-center px-024 pb-016 pt-024 gap-3">
                  <div className="p-2 bg-gray7 rounded-full">
                     <div className="bg-black1 p-2 rounded-full">
                        <img src={trashIcon} alt="icon" />
                     </div>
                  </div>
                  <label className="text-20 font-semibold text-black1">
                     {discountText('delete_discount')}
                  </label>
               </div>
               <div>
                  <div className="px-6">
                     <span className="text-gray5 text-sm">
                        {discountText('confirm_delete_discount')}
                     </span>
                     <p className="text-gray5 text-sm mt-2">
                        {discountText('warning_delete_discount_in_orders')}
                     </p>
                     {state?.promotion_id && (
                        <p className="text-gray5 text-sm mt-2">
                           {discountText('note_discount_in_promotion')}
                        </p>
                     )}
                  </div>
               </div>
               <div className="flex flex-row justify-between space-x-4 h-[48px] my-4 px-6">
                  <button
                     className="border border-gray6 rounded-lg font-bold bg-white grow h-full flex justify-center items-center text-cyan1"
                     onClick={onClose}
                  >
                     {t('cancel')}
                  </button>
                  <button
                     className="rounded-lg font-bold bg-red-500 grow h-full flex justify-center items-center text-white"
                     onClick={onSubmit}
                  >
                     {loading ? <CircularProgress size={16} /> : t('delete')}
                  </button>
               </div>
            </Box>
         </Modal>
      </div>
   )
}